import _ from 'lodash';

export default async function AllSettledObject(promisesObject: Record<string, Promise<any>>) {
  const keys = Object.keys(promisesObject);
  const settledValues = await Promise.allSettled(Object.values(promisesObject));

  return _.zipObject(keys, settledValues);
}
